import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { TariffTile } from '@beef/smart-kit';

import { slConstructorClick } from 'utils/analytics/sl';
import { ymMobTariffsToDetail } from 'utils/analytics/tariffCard';
import { useOnScreenAnalytics } from 'pages/TariffsCatalog2021/hooks/useOnScreenAnalytics';
import { tariffCardAnalyticsProps } from 'pages/TariffsCatalog2021/utils/tariffCardAnalyticsProps';
import { ymAnalyticTariffCardClick } from 'pages/TariffsCatalog2021/utils/ymAnalyticTariffCardClick';
import { ETariffsVkGoals, vkPushSimTariffEvent } from 'utils/analytics/simTariffVkEvents';
import { BuySimModal } from 'pages/TariffsCatalog2021/components/BuySimModal';

/** Компонент-обертка карточки тарифа в каталоге */
export const Tariff = ({ data: { type, ...data } = {}, authStatus, buyModalContent }) => {
  const [isOpen, setIsOpen] = useState(false);
  /* Устанавливаем presetsRef на обертку карточки тарифа */
  const presetsRef = useRef(null);

  /* Отправка аналитики при видимости блока карточки тарифа */
  useOnScreenAnalytics({
    ref: presetsRef,
    threshold: 0.5,
    payload: tariffCardAnalyticsProps({ data, type: 'view', authStatus }),
  });

  return (
    <div ref={presetsRef}>
      <TariffTile
        {...data}
        onLinkClick={(event) => {
          /* BCNC-7422 – eSIM временный сценарий (на время производства целевого)
           * Открываем модалку с предложением покупки сим без перехода на сам тариф */
          if (data.withBuyModal) {
            event.preventDefault();
            setIsOpen(true);
          }

          event.stopPropagation();
          slConstructorClick(data);
          ymMobTariffsToDetail(data);
          ymAnalyticTariffCardClick({
            data,
            authStatus,
            type: 'go_to_detail',
          });
          vkPushSimTariffEvent(data?.alias, ETariffsVkGoals.SimTariffOpenCart);
        }}
      />
      <BuySimModal
        buyModalContent={buyModalContent}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        tariffInfo={{
          eSimOrderLink: buyModalContent?.eSimOrderLink,
          soc: data.soc,
          dpcId: data.id,
        }}
      />
    </div>
  );
};

Tariff.propTypes = {
  authStatus: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object,
  buyModalContent: PropTypes.shape({
    eSimOrderLink: PropTypes.string,
    title: PropTypes.string,
    variants: PropTypes.shape({
      esim: PropTypes.shape({
        icon: PropTypes.string,
        title: PropTypes.string,
        text: PropTypes.string,
      }),
      sim: PropTypes.shape({
        icon: PropTypes.string,
        title: PropTypes.string,
        text: PropTypes.string,
      }),
    }),
    desktopESimInstruction: PropTypes.shape({
      info: PropTypes.shape({
        qrCode: PropTypes.string,
        title: PropTypes.string,
        text: PropTypes.string,
      }),
      steps: PropTypes.arrayOf(
        PropTypes.shape({
          icon: PropTypes.string,
          title: PropTypes.string,
          text: PropTypes.string,
        }),
      ),
      title: PropTypes.string,
    }),
  }),
};
